import { render, staticRenderFns } from "./yn.vue?vue&type=template&id=22bffffa"
import script from "./yn.vue?vue&type=script&lang=js"
export * from "./yn.vue?vue&type=script&lang=js"
import style0 from "./yn.vue?vue&type=style&index=0&id=22bffffa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports